const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

const pxToRem = (pixels) => {
  return `${pixels / 16}rem`;
};

const typography = {
  h1: {
    fontFamily,
    fontSize: pxToRem(48),
    fontWeight: 600,
    lineHeight: pxToRem(64),
    letterSpacing: '0.15px',
  },
  h2: {
    fontFamily,
    fontSize: pxToRem(40),
    fontWeight: 500,
    lineHeight: pxToRem(56),
    letterSpacing: '0.15px',
  },
  h3: {
    fontFamily,
    fontSize: pxToRem(32),
    fontWeight: 500,
    lineHeight: pxToRem(48),
    letterSpacing: '0.15px',
  },
  h4: {
    fontFamily,
    fontSize: pxToRem(24),
    fontWeight: 400,
    lineHeight: pxToRem(40),
    letterSpacing: '0.15px',
  },
  h5: {
    fontFamily,
    fontSize: pxToRem(20),
    fontWeight: 400,
    lineHeight: pxToRem(32),
    letterSpacing: '0.15px',
  },
  h6: {
    fontFamily,
    fontSize: pxToRem(18),
    fontWeight: 400,
    lineHeight: pxToRem(28),
    letterSpacing: '0.15px',
  },
  body1: {
    fontFamily,
    fontSize: pxToRem(16),
    fontWeight: 400,
    lineHeight: pxToRem(24),
    letterSpacing: '0.15px',
  },
  body2: {
    fontFamily,
    fontSize: pxToRem(14),
    fontWeight: 400,
    lineHeight: pxToRem(24),
    letterSpacing: '0.15px',
  },
  subtitle1: {
    fontFamily,
    fontSize: pxToRem(16),
    fontWeight: 600,
    lineHeight: pxToRem(24),
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontFamily,
    fontSize: pxToRem(14),
    fontWeight: 500,
    lineHeight: pxToRem(20),
    letterSpacing: '0.15px',
  },
  caption: {
    fontFamily,
    fontSize: pxToRem(12),
    fontWeight: 400,
    lineHeight: pxToRem(16),
    letterSpacing: '0.15px',
  },
};

module.exports = { typography };
